export interface OptOutFields {
  /**
   * Value of the field
   */
  value: string;
  /**
   * Flag to checked prop
   */
  checked: boolean;
  /**
   * Flag to reset 
   */
  isReset?: boolean;
}

export interface InitialState {
  /**
   * OptOuts selected
   */
  selectedOptOuts: string[];
  /**
   * OptOut mode
   */
  mode: ParentOptOutModes;
}

export enum OptOutModes {
  SAVE = "save",
  UPDATE = "update"
}

export enum ParentOptOutModes {
  VIEW = "view",
  CREATE = "Create",
  EDIT = "Edit"
}
